var lcssafira = lcssafira ||  {};
lcssafira.confirmmodal = lcssafira.confirmmodal || {};

;(function(namespace, $){

  // inicializa modal de confirmacao
  // element = id ou classe do elemento (.element, #element)
  // message = a mensagem a ser passada para o modal
  function ConfirmModal(element, message, modal_type, titulo) {

    modal_type = (typeof modal_type !== 'undefined') ?  modal_type : "confirm";
    titulo = (typeof titulo !== 'undefined') ?  titulo : "Tem certeza que deseja excluir?";
      
    if(modal_type == 'confirm') {

      $('body').on('click', element , function(event) {
        event.preventDefault();

        var link = $(this).attr('href');

        bootbox.confirm({ 
            size: 'large',
            message: message,
            title: titulo, 
            callback: function(result){

              if (result) {
                window.location.href= link;
              }
            }
        });
      });
    } 

    else if(modal_type == 'confirm-edit') {

      $('body').on('click', element , function(event) {
        event.preventDefault();

        var id_pedido = $(this).attr('data-id-pedido');

        bootbox.confirm({ 
            size: 'large',
            message: message + id_pedido,
            title: '', 
            callback: function(result){

              if (result) {
                app.pcc.responseModalLiberaPcc(id_pedido);
              }
            }
        });
      });
    } 

    else {
      bootbox.alert(message.codigo + ': ' + message.mensagem);
    }
  }

  namespace.ConfirmModal = ConfirmModal;

})(lcssafira.confirmmodal, jQuery);